
const texts = {
    noTieneDoc: 'No se encuentran documentos para firmar.',
    title: 'Documentos A Firmar',
    errorMessages: {
      rechazo:'EF003: No se pudo completar la acción. Probá de nuevo en unos minutos. Si sigue el problema, escribí a soporte.',
      networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
      noCoincidencia: 'No se encontraron resultados que coincidan con tu búsqueda.',
      peticionTardo:'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
    },
  };
  
  export default texts;
  